import { fetchJSON } from "./utils";

export async function fetchAll(interaction_organization_id) {
  const url = "/api/interaction-tags/";
  let params = { interaction_organization_id };
  return fetchJSON(url, params, null, "get", false);
}

export async function createInteractionTag(data) {
  const url = "/api/interaction-tags/";
  let params = null;
  return fetchJSON(url, params, data, "post");
}

export async function deleteInteractionTag(data) {
  const url = "/api/interaction-tags/delete";
  let params = null;
  return fetchJSON(url, params, data, "post");
}
